<template lang="pug">
.d-flex.flex-wrap.gap-16(v-if="Object.keys(event).length")
  template(v-for="(chip, index) in subsectionsContent[category]")
    template(v-if="chip.alwaysShow || isEditable || (!chip.editable || (chip.selectData && chip.selectData.value && chip.selectData.items.length))")
      info-select(
        itemValue="value"
        itemText="text"
        :value="chip.selectData ? chip.selectData.value : null"
        :title="chip.selectData ? chip.selectData.title : ''"
        :items="chip.selectData ? chip.selectData.items : []"
        :is-editable="isEditing && chip.editable"
        @input="changeEventInfo($event, chip.type)"
      )
        template(#activator="{ on }")
          template(v-if="!chip.hide || isEditing || isEditable")
            .relative.d-flex.align-center.px-3.py-2.rounded-12.weight-500.gap-8.section-bg-current(
              :key="index"
              :style="{ backgroundColor }"
              :class=`{
                'body-2': $vuetify.breakpoint.smAndDown,
                'body-1': $vuetify.breakpoint.mdAndUp,
              }`
            )
              template(v-if="isEditable && chip.editable && !chip.hideInstruction")
                template(v-if="!chip.hide")
                  v-icon(
                    color="redesignSuccess"
                  ) $icheck-all
                template(v-else)
                  v-icon(
                    color="redesignError"
                    :size="20"
                  ) $iinfo

              tooltip-wrap(
                :value="!!chip.tooltip && showTooltips && !chip.hideTooltip"
                content-class="redesign redesignControlsBackground redesign-box-shadow rounded-8 opacity-100"
                activator-class="d-block"
                top
              )
                template(#reason)
                  template(v-if="chip.tooltip")
                    p.redesignPrimaryDarken--text {{ chip.tooltip }}
                span(v-if="category === 'info'") {{ chip.text }}
                span(v-if="category === 'dates'")
                  span.mr-1 {{ chip.text }}:
                  template(v-if="chip.end")
                    | {{ chip.start }}
                    | - {{ chip.end }}
                  template(v-else)
                    | {{ chip.start }}
                template(v-if="chip.icon && chip.icon.is")
                  v-icon(
                    v-bind="chip.icon.attrs"
                  ) {{ chip.icon.is }}
              template(v-if="isEditing && chip.editable")
                template(v-if="chip.type !== CHIP_TYPE.ACCEPTING && chip.type !== CHIP_TYPE.STAGE && chip.type !== CHIP_TYPE.AGE")
                  app-button.px-0.ml-1.section-bg-current(
                    :color="backgroundColor"
                    v-on="on"
                    height="24px"
                    min-width="24px"
                    min-height="24px"
                  )
                    v-icon(
                      color="redesignPrimaryDarken"
                      :size="18"
                    ) $ipencil
                template(v-else)
                  app-button.px-0.ml-1.section-bg-current(
                    :color="backgroundColor"
                    :height="24"
                    :min-width="24"
                    :min-height="24"
                    @click="$emit('edit', chip)"
                  )
                    v-icon(
                      color="redesignPrimaryDarken"
                      :size="18"
                    ) $ipencil

  template(v-if="eventsByLevelsData.length > 1")
    template(v-for="event in eventsByLevelsData")
      .relative.d-flex.align-center.pa-3.rounded-12.weight-500.gap-4.section-bg-current(
        :key="event.id"
        :style="{ backgroundColor }"
        :class=`{
          'body-2': $vuetify.breakpoint.smAndDown,
          'body-1': $vuetify.breakpoint.mdAndUp,
        }`
      )
        v-icon.mr-1(color="redesignBlack") {{ `$icrown-${5 - event.level}` }}
        p
          span {{ LEVEL_NAMES[event.level] }} этап
          template(v-if="(event.event_stage_start_at && event.event_stage_end_at) || (event.start_at && event.end_at)")
            span
              | :
              | {{ event.event_stage_start_at || event.start_at | localeFormatDefault | readableDate }}
              | - {{ event.event_stage_end_at || event.end_at | localeFormatDefault | readableDate }}
        template(v-if="isEditing && event.editable")
          app-button.px-0.ml-1.section-bg-current(
            :color="backgroundColor"
            :height="24"
            :min-width="24"
            :min-height="24"
            @click="$emit('edit', event)"
          )
            v-icon(
              color="redesignPrimaryDarken"
              :size="18"
            ) $ipencil
</template>

<script>
/* eslint-disable indent  */
import mixinTime from '@/mixins/mixinTime';
import { EVENT_MEMBER_TYPE_TEXT, EVENT_MEMBER_TYPE, LEVELS_LABELS } from '@/modules/UserEventLanding/constants';
import { LEVEL_NAMES } from '@/constants/level';
// import { EVENT_OLD_TYPE_TEXT, EVENT_OLD_TYPE } from '@/modules/Events/constants.js';
import AppButton from '@/components/user-redesign/controls/AppButton.vue';
import InfoSelect from '@/modules/UserEventLanding/components/event-landing/about/InfoSelect.vue';
import { EVENT_PAY_TYPES } from '@/modules/Moderation/constants';
import { localeFormatDefault } from '@/plugins/date-print';
import Event from '@/models/list/event';
import { DEFAULT_NOMINATION } from '@/modules/Events/constants';

export const CHIP_TYPE = {
  ACCEPTING: 'accepting_at',
  STAGE: 'event_stage',
  MEMBER: 'event_member',
  PROJECT: 'event_project',
  OLD_TYPE: 'event_old_type',
  AGE: 'event_age',
};

export default {
  name: 'EventInfoChips',
  filters: {
    localeFormatDefault,
  },
  components: {
    AppButton,
    InfoSelect,
  },

  mixins: [mixinTime],
  props: {
    event: {
      type: Object,
      default: () => ({}),
    },
    color: {
      type: String,
      default: 'redesignControlsBackground',
    },
    category: {
      type: String,
      default: 'info',
    },
    projectsNames: {
      type: Object,
      default: null,
    },
    eventsByLevels: {
      type: Boolean,
      default: false,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    onlyLevelsData: {
      type: Boolean,
      default: false,
    },
    showTooltips: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      CHIP_TYPE,
      templateEvents: [],
      LEVEL_NAMES,
    };
  },

  computed: {
    // REFACTOR: принимать из пропсов модель и убрать это
    isOwner() {
      return this.$user?.isAuthenticated && this.event.owner_id === this.$user?.data?.id;
    },
    backgroundColor() {
      return this.$vuetify.theme.isDark
        ? this.$vuetify.theme.themes.dark[this.color] ?? this.color
        : this.$vuetify.theme.themes.light[this.color] ?? this.color;
    },
    subsectionsContent() {
      if (this.onlyLevelsData) {
        return {
          dates: [],
          info: [],
        };
      }

      const event = new Event(this.event);
      const { options, event_stage_start_at, event_stage_end_at, organization_name, level, active_members_count } = this.event;
      const {
        start_accepting_at,
        end_accepting_at,
        event_member_type,
        project_id,
        // directory_event_member_type_ids,
        pay_type,
        price,
        max_age,
        min_age,
      } = options;
      // const [member_type_id] = directory_event_member_type_ids || [];

      const currentLevel = typeof level === 'object' && level !== null ? level.id : level;

      const nominationsCount = this.eventActualNominations.length;

      const EditProjectItems = Object.keys(this.projectsNames || {}).map((projectId) => ({
        value: Number(projectId),
        text: this.projectsNames[projectId],
      }));

      const { readableDate, readableDateWithTime } = this.$options.filters;
      const acceptingStart = readableDate(start_accepting_at);
      const acceptingEnd = readableDate(end_accepting_at);
      const stageStart = readableDate(event_stage_start_at);
      const stageEnd = readableDate(event_stage_end_at);

      return {
        dates: [
          // ...!event.isHighest ? [{
          //   text: 'Прием заявок',
          //   start: acceptingStart,
          //   end: acceptingStart !== acceptingEnd ? acceptingEnd : null,
          //   type: CHIP_TYPE.ACCEPTING,
          //   editable: true,
          //   alwaysShow: start_accepting_at && end_accepting_at, // To do: придумать что-нибудь адекватное этому костылю
          //   hide: !(start_accepting_at && end_accepting_at),
          //   tooltip: `${readableDateWithTime(start_accepting_at)} - ${readableDateWithTime(end_accepting_at)}`,
          //   hideTooltip: this.isOwner,
          // }] : [],
          ...!event.isAdminTemplate ? [{
            text: 'Даты проведения',
            start: stageStart,
            end: stageStart !== stageEnd ? stageEnd : null,
            type: CHIP_TYPE.STAGE,
            tooltip: 'Даты подставляются из созданных этапов мероприятия',
            hideTooltip: !this.isOwner,
          }] : [],
        ],
        info: [
          ...!event.isAdminTemplate ? [{
            text: organization_name,
            hide: !organization_name,
          }] : [],
          {
            text: LEVELS_LABELS[currentLevel],
          },
          ...(nominationsCount > 0
            ? [
                {
                  text: `
                ${nominationsCount}
                ${this.event.options.frontend_params.getEntityName('nominations_override', nominationsCount)}
              `,
                },
              ]
            : []),
          ...!event.isAdminTemplate ? [{
            text: this.$tc('user_event_landing.options.active_members_count', active_members_count),
          }] : [],
          {
            hide: !event_member_type,
            text: event_member_type ? `${EVENT_MEMBER_TYPE_TEXT[event_member_type]} участие` : 'Тип участия: -',
            type: CHIP_TYPE.MEMBER,
            editable: !event.isActive,
            selectData: {
              title: 'Тип участия',
              value: event_member_type || null,
              items: [
                {
                  value: EVENT_MEMBER_TYPE.SINGLE,
                  text: EVENT_MEMBER_TYPE_TEXT[EVENT_MEMBER_TYPE.SINGLE],
                },
                {
                  value: EVENT_MEMBER_TYPE.TEAM,
                  text: EVENT_MEMBER_TYPE_TEXT[EVENT_MEMBER_TYPE.TEAM],
                },
              ],
            },
          },
          {
            hideInstruction: true,
            hide: !project_id || !this.projectsNames,
            text: `Проект: ${this.projectsNames && project_id ? this.projectsNames[project_id] : '-'}`,
            type: CHIP_TYPE.PROJECT,
            editable: true,
            selectData: {
              title: 'Проект мероприятия',
              value: project_id || null,
              items: [...EditProjectItems],
            },
          },
          // {
          //   hide: !member_type_id,
          //   text:
          //     member_type_id && EVENT_OLD_TYPE_TEXT[member_type_id] ? EVENT_OLD_TYPE_TEXT[member_type_id] : 'Возрастная категория: -',
          //   type: CHIP_TYPE.OLD_TYPE,
          //   editable: true,
          //   selectData: {
          //     title: 'Возрастная категория',
          //     value: member_type_id || null,
          //     items: [
          //       {
          //         value: EVENT_OLD_TYPE.kids,
          //         text: EVENT_OLD_TYPE_TEXT[EVENT_OLD_TYPE.kids],
          //       },
          //       {
          //         value: EVENT_OLD_TYPE.students,
          //         text: EVENT_OLD_TYPE_TEXT[EVENT_OLD_TYPE.students],
          //       },
          //       {
          //         value: EVENT_OLD_TYPE.adults,
          //         text: EVENT_OLD_TYPE_TEXT[EVENT_OLD_TYPE.adults],
          //       },
          //     ],
          //   },
          // },
          {
            text: `Возраст участников: ${min_age} - ${max_age}`,
            type: CHIP_TYPE.AGE,
            editable: true,
            alwaysShow: true,
          },
          ...(pay_type !== EVENT_PAY_TYPES.FREE && price
            ? [
                {
                  text: `Стоимость участия: ${price}`,
                  icon: {
                    is: 'mdi-currency-rub',
                    attrs: {
                      size: 16,
                      color: 'redesignMainBlack',
                    },
                  },
                },
              ]
            : []),
        ],
      };
    },
    eventsByLevelsData() {
      const { templateEvents, event } = this;
      return [...templateEvents, event.highest_event].sort(({ level: a }, { level: b }) => a - b);
    },

    // @celioniz, это костыль-копипаста из модели Event,
    // потому что в компоненте выше (SectionAbout) прокидывается не модель, а объект.
    // Трюк с new Event(this.event) не прокатит, потому что как минимум поле level в this.event будет объектом (из модели).
    // а не числом (как ожидается в конструкторе модели)
    eventActualNominations() {
      const defaultNomination = this.event.nominations.find((nomination) => nomination.name === DEFAULT_NOMINATION.NAME);
      if (!defaultNomination) {
        return nominations || [];
      }

      if (this.event.options.has_nominations) {
        return this.event.nominations.filter((nomination) => nomination.id !== defaultNomination.id);
      }

      return [defaultNomination];
    },
  },

  async created() {
    if (this.eventsByLevels) {
      await this.loadTemplateEvents();
    }
  },

  methods: {
    async loadTemplateEvents() {
      const { templates } = this.event;
      if (templates && templates.length) {
        const eventIds = templates.map(({ template_event_id }) => template_event_id);

        if (eventIds && eventIds.length) {
          const paramsEvents = {
            'search[id]': eventIds,
            expand: 'options',
          };

          const response = await this.$api.events.getPublicEvents(paramsEvents);

          const eventsData = response.data.data;

          this.templateEvents = eventsData.map((event) => ({
            ...event,
            level: templates.find(({ template_event_id: id }) => id === event.id)?.level,
          }));
        }
      }
    },
    changeEventInfo(value, type) {
      const info = { value, option: null };
      switch (type) {
        case CHIP_TYPE.MEMBER: {
          info.option = 'event_member_type';
          break;
        }
        case CHIP_TYPE.PROJECT: {
          info.option = 'project_id';
          break;
        }
        case CHIP_TYPE.OLD_TYPE: {
          info.option = 'directory_event_member_type_ids';
          info.value = [value];
          break;
        }
        default:
          break;
      }
      this.$emit('edit', info);
    },
  },
};
</script>
